export enum TipoActivo
{
    BienesRaices = "Bienes Raíces",
    Vehiculos = "Vehículos",
    Inversiones = "Inversiones",
    Otros = "Otros"
}